var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 99,
    viewBox: "0 0 150 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.376 0H11.6257C5.21581 0 0 5.21581 0 11.6257V19.3955V36.1389V86.4801C0 92.89 5.21581 98.1042 11.6257 98.1042H138.376C144.786 98.1042 150 92.89 150 86.4801V36.1389V19.3955V11.6257C150 5.21581 144.786 0 138.376 0ZM4.82635 11.6257C4.82796 7.87602 7.87602 4.82796 11.6241 4.82796H138.374C142.122 4.82796 145.17 7.87763 145.17 11.6257V16.9816H4.82635V11.6257ZM145.172 86.4785C145.172 90.225 142.122 93.2746 138.376 93.2746H11.6257C7.87763 93.2746 4.82796 90.225 4.82796 86.4785V38.5513H145.172V86.4785ZM145.172 33.7233H4.82796V21.8079H145.172V33.7233Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3303 83.7587C27.9732 83.7587 31.7487 79.9849 31.7487 75.3468C31.7487 70.7055 27.9732 66.9285 23.3303 66.9285C18.6907 66.9285 14.9152 70.7055 14.9152 75.3468C14.9152 79.9849 18.6907 83.7587 23.3303 83.7587ZM23.3303 71.7564C25.3098 71.7564 26.9207 73.3674 26.9207 75.3468C26.9207 77.3231 25.3098 78.9308 23.3303 78.9308C21.3525 78.9308 19.7431 77.3231 19.7431 75.3468C19.7431 73.3674 21.3525 71.7564 23.3303 71.7564Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3322 78.044H109.349C110.683 78.044 111.763 76.9642 111.763 75.63C111.763 74.2959 110.683 73.2161 109.349 73.2161H41.3322C39.9981 73.2161 38.9182 74.2959 38.9182 75.63C38.9182 76.9642 39.9981 78.044 41.3322 78.044Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.870057dfae685a33ed355799f88633c3.svg";
export { ForwardRef as ReactComponent };